/**
 * Created by emanuele on 03/07/2025.
 */
import React from 'react';

const SiNoTableColumn = ({ value }) => (
    <div>
        {value ? <label className="ui green rounded label">SI</label> : <label className="ui red rounded label">NO</label>}
    </div>
);

export default SiNoTableColumn;


/** WEBPACK FOOTER **
 ** ./src/components/SiNoTableColumn.jsx
 **/